import Stack from '@mui/material/Stack'
import Tabs from 'components/common/Tabs'
import styles from 'containers/VerticalPage/common/styles.scss'
import React, { FC, useContext, useMemo, useRef, useState } from 'react'
import { VerticalContext } from 'store/verticals/Context'
import Registry from '../../common/Registry/Registry'
import sxStyles from './styles'
import { getTabsList, tabsIds } from './utils'
import OverviewTab from '../../common/Company/OverviewTab/OverviewTab'
import EmployeesTab from '../../common/Company/EmployeesTab/EmployeesTab'
import TabBox from '../../common/TabBox/TabBox'
import ContactInfo from '../../common/ContactInfo_New/ContactInfo'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'
import { useParams } from 'react-router-dom'

const tabsList = getTabsList()

const Details: FC = () => {
  const { caseId } = useParams<{ caseId: string }>()
  const [activeTab, setActiveTab] = useState<number>(tabsIds.OVERVIEW)

  const { verticalEntity } = useContext(VerticalContext)
  const currentZone = useSelector(selectCurrentZone)

  const handleTabClick = (event: React.SyntheticEvent<Element, Event>, value: number) => {
    setActiveTab(value)
  }

  const tabContainerRef = useRef<HTMLInputElement>(null)

  const contentByTabMap: { [key: number]: JSX.Element } = useMemo(
    () => ({
      [tabsIds.OVERVIEW]: (
        <TabBox>
          <OverviewTab companyAggsIndices={currentZone?.nexusAggsIndices} />
        </TabBox>
      ),
      [tabsIds.REGISTRY]: (
        <div style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <Registry />
        </div>
      ),
      [tabsIds.EMPLOYEES]: (
        <TabBox sx={{height: '650px'}}>
          <EmployeesTab
            caseId={caseId}
            verticalEntity={verticalEntity}
            activityIndices={currentZone?.nexusActivityIndices}
          />
        </TabBox>
      ),
      [tabsIds.CONTACT_INFO]: (
        <div style={{ paddingTop: '16px', paddingBottom: '16px' }}>
          <ContactInfo contactInfo={verticalEntity?.contactInfo} />
        </div>
      ),
    }),
    [verticalEntity],
  )

  return (
    <Stack sx={sxStyles.container}>
      <div className={styles.tabsWrapper}>
        <Tabs
          tabs={tabsList}
          value={activeTab}
          tabsClasses={{
            root: styles.root,
            flexContainer: styles.flexContainer,
          }}
          tabClasses={{
            root: styles.tabRoot,
            disabled: styles.tabDisabled,
          }}
          onChange={handleTabClick}
        />
      </div>
      <Stack
        sx={{
          ...(tabsIds.CONTACT_INFO === activeTab ? { overflow: 'hidden' } : sxStyles.tabWrapper),
          ...(tabsIds.OVERVIEW === activeTab || tabsIds.CONTACT_INFO === activeTab || tabsIds.EMPLOYEES === activeTab
            ? { height: '100%' }
            : {}),
        }}
        ref={tabContainerRef}
      >
        {contentByTabMap[activeTab]}
      </Stack>
    </Stack>
  )
}

export default Details
